import React, { useEffect } from "react";
import { PortForm } from "./Forms/PortForm";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Stack } from "react-bootstrap";
import { Container, Form, Spinner } from "reactstrap";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import {
  useGetOnePortQuery,
  useUpdatePortMutation,
} from "../../services/basicData/basicData";
import { useParams } from "react-router";
import { FormSkeleton } from "./FormFieldSkeletons";

export const EditPort = () => {
  const { t } = useTranslation();

  const { id } = useParams();
  const {
    data: portResponse,
    isLoading,
    isFetching,
  } = useGetOnePortQuery({ id });
  const port = portResponse?.data?.data;
  const loading = isLoading || isFetching;
  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm();
  const { mutate: updatePort, isPending } = useUpdatePortMutation(setError);

  const onSubmit = (data) => {
    updatePort(data);
  };

  useEffect(() => {
    if (port) {
      reset(port);
    }
  }, [port, reset]);

  return (
    <Stack gap={2}>
      <PageHeader
        title={t("EDIT_PORT")}

      />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          {loading ? (
            <FormSkeleton />
          ) : (
            <>
              <PortForm control={control} errors={errors} />
              <Button variant="primary" type="submit" disabled={isPending}>
                {isPending ? (
                  <>
                    <Spinner size="sm" />
                    {t("UPDATING_PORT")}
                  </>
                ) : (
                  t("UPDATE_PORT")
                )}
              </Button>
            </>
          )}
        </Form>
      </Container>
    </Stack>
  );
};

